import { Box, Stack, Text, Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'

const WECHAT_OFFICIAL_WEBPAGE_URL = 'https://mp.weixin.qq.com/s/Br6fyj9KSt6ZGcxFYuIGSQ'

export const Route = createFileRoute('/(test)/test/wechat-official-webpage')({
	component: WechatOfficialWebpage,
})

function WechatOfficialWebpage() {
	return (
		<Stack h="100vh" gap={12} p={16}>
			<Box>
				<Title order={1} size="h3">
					微信公众号 iframe 测试
				</Title>
				<Text c="var(--tint-secondary)" size="sm">
					{WECHAT_OFFICIAL_WEBPAGE_URL}
				</Text>
			</Box>

			<Box
				component="iframe"
				src={WECHAT_OFFICIAL_WEBPAGE_URL}
				title="微信公众号文章"
				w="100%"
				flex={1}
				bd="1px solid var(--tint-separator)"
				style={{
					borderRadius: 8,
				}}
			/>
		</Stack>
	)
}
